import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BroadcastChannelService implements OnDestroy {
    private broadcastChannel: BroadcastChannel | null = null;
    private message = new Subject<any>();

    constructor(private ngZone: NgZone) {
        if (typeof BroadcastChannel !== 'undefined') {
            try {
                this.broadcastChannel = new BroadcastChannel('session-expire');

                this.broadcastChannel.addEventListener('message', (event: MessageEvent) => {
                    this.ngZone.run(() => {
                        this.message.next(event.data);
                    });
                });
            } catch (err) {
                console.error('Failed to create BroadcastChannel', err);
            }
        } else {
            console.error('BroadcastChannel is not supported');
        }
    }

    onMessage(): Observable<any> {
        return this.message.asObservable();
    }

    postMessage(data: any): void {
        try {
            this.broadcastChannel?.postMessage(data);
        } catch (err) {
            console.error("Broadcast Service postMessage errror:", err);
        }
    }

    ngOnDestroy(): void {
        this.broadcastChannel?.close();
        this.message.complete();
    }
}